module.exports = __webpack_public_path__ + "img/icon_3_off.4c36cb21.svg";